webpackJsonp([190672807361987],{

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "3e persoon"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ego"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "tu"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ea"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jij, u"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "mihi"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "tibi"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan haar"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "me"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "te"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eam"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "haar"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "3e persoon"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eae"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "wij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hen"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eas"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "3e persoon"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ego"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "tu"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ea"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jij, u"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "mihi"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "tibi"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan haar"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "me"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "te"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eam"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "haar"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "me"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "te"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eo"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ea"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "haar"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "3e persoon"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eae"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "wij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hen"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eas"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "3e persoon"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ego"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "tu"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ea"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jij, u"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "mei"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "tui"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eius"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eius"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van haar"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "mihi"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "tibi"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan haar"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "me"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "te"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eam"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "haar"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "me"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "te"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eo"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ea"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "haar"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "3e persoon"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eae"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "wij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nostrum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vestrum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eorum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "earum"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van hen"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hen"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eas"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 3 },
	            "3e persoon"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ego"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "tu"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ea"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "id"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ik"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jij, u"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "het"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "mei"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "tui"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eius"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eius"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eius"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van haar"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van het"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "mihi"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "tibi"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan haar"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan het"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "me"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "te"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eam"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "id"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "haar"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "het"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "me"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "te"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eo"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ea"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eo"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "mij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jou"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "haar"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "het"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "1e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "2e persoon"
	          ),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 3 },
	            "3e persoon"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement("th", null),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ei"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ea"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "wij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "zij"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nostrum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vestrum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eorum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "earum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eorum"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "van hen"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "aan hen"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eas"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ea"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col no-bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "nobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "vobis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "no-bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "eis"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "ons"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "jullie"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "em",
	              null,
	              "hen"
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _persVnw = __webpack_require__(662);
	
	var _persVnw2 = _interopRequireDefault(_persVnw);
	
	var _persVnw3 = __webpack_require__(663);
	
	var _persVnw4 = _interopRequireDefault(_persVnw3);
	
	var _persVnw5 = __webpack_require__(664);
	
	var _persVnw6 = _interopRequireDefault(_persVnw5);
	
	var _persVnw7 = __webpack_require__(665);
	
	var _persVnw8 = _interopRequireDefault(_persVnw7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "2",
	  table: _persVnw2.default
	}, {
	  les: "3",
	  table: _persVnw4.default
	}, {
	  les: "4",
	  table: _persVnw6.default
	}, {
	  les: "40",
	  table: _persVnw8.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, {
	    defaultChapter: "40",
	    data: data,
	    title: "Persoonlijk voornaamwoord"
	  });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-persoonlijk-voornaamwoord-js-2945264894c1b28497c4.js